var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.13227 16.1182C8.96908 13.728 13.6098 9.08725 16 3.25044C18.3902 9.08725 23.0309 13.728 28.8677 16.1182C23.0309 18.5083 18.3902 23.1491 16 28.9859C13.6098 23.1491 8.96908 18.5083 3.13227 16.1182Z","fill":"white","stroke":"#374151","strokeWidth":"2"}));
}

Star.defaultProps = {"width":"32","height":"33","viewBox":"0 0 32 33","fill":"none"};

module.exports = Star;

Star.default = Star;
